import { render } from "./CasesList.vue?vue&type=template&id=6bd35ac7&scoped=true"
import script from "./CasesList.vue?vue&type=script&lang=js"
export * from "./CasesList.vue?vue&type=script&lang=js"

import "./CasesList.vue?vue&type=style&index=0&id=6bd35ac7&scoped=true&lang=css"

import exportComponent from "/home/entheo/wetouch2_bce_2022/site_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd35ac7"]])

export default __exports__